import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Warning, Clock } from '@phosphor-icons/react';

const STATUS_COLORS = {
  active: 'bg-green-50 text-green-700 border-green-200',
  archived: 'bg-gray-50 text-gray-600 border-gray-200',
  closed: 'bg-blue-50 text-blue-600 border-blue-200',
};

export const CaseCard = ({ c }) => (
  <Link to={`/cases/${c._id}`} data-testid={`case-card-${c._id}`}
    className="block bg-white border border-[#E5E7EB] rounded-lg p-5 hover:shadow-sm hover:border-[#002FA7]/30 transition-all group">
    <div className="flex items-start justify-between mb-3">
      <span className={`text-xs font-ibm font-semibold px-2 py-0.5 rounded border ${STATUS_COLORS[c.status] || STATUS_COLORS.active}`}>{c.status?.toUpperCase()}</span>
      <div className="flex items-center gap-1">
        {c.my_role && <span className="text-xs px-1.5 py-0.5 bg-purple-50 text-purple-700 rounded font-ibm">{c.my_role}</span>}
        <span className="text-xs text-[#6B7280] font-ibm">{c.case_type}</span>
      </div>
    </div>
    <h3 className="font-outfit text-lg font-semibold text-[#09090B] mb-2 group-hover:text-[#002FA7] transition-colors line-clamp-2">{c.title}</h3>
    {c.description && <p className="text-sm text-[#6B7280] font-ibm mb-4 line-clamp-2">{c.description}</p>}
    <div className="flex items-center gap-4 text-xs text-[#6B7280] font-ibm border-t border-[#E5E7EB] pt-3 mt-auto">
      <span className="flex items-center gap-1"><FileText size={14} /> {c.documents_count || 0} docs</span>
      <span className="flex items-center gap-1"><Clock size={14} /> {c.timeline_count || 0} events</span>
      <span className="flex items-center gap-1"><Warning size={14} /> {c.contradictions_count || 0}</span>
    </div>
  </Link>
);
